var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRegularFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "30px",
    viewBox: "0 0 26 30",
    xmlns: "http://www.w3.org/2000/svg",
    className: "user",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2,17.812 C16.534,17.812 15.733,18.749 13,18.749 C10.267,18.749 9.471,17.812 7.8,17.812 C3.47202581,17.8340384 -0.0193776742,21.3590131 -8.027226e-05,25.687 L-8.027226e-05,27.187 C-0.00719724869,28.7330155 1.239987,29.9922866 2.786,30 L23.214,30 C24.7596208,29.9922861 26.0066434,28.7336257 26.0000849,27.188 L26.0000849,25.688 C26.0199315,21.3596233 22.5283664,17.8340379 18.2,17.812 L18.2,17.812 Z M13,16.875 C16.4201231,16.9078327 19.5217607,14.8728192 20.8533047,11.7223732 C22.1848488,8.57192716 21.4828769,4.92930838 19.0759214,2.49931151 C16.6689658,0.0693146465 13.0332,-0.667328611 9.87021137,0.634140712 C6.7072227,1.93561003 4.64291626,5.01771936 4.64291626,8.438 C4.62251493,13.0748785 8.3631368,16.8513086 13,16.875 L13,16.875 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRegularFilled);
export default __webpack_public_path__ + "static/media/user-regular-filled.c3901314.svg";
export { ForwardRef as ReactComponent };